/**
 * Keep track of portal parents for clickoutside checks
 */
export const portalParents: WeakMap<Node, Node> = new WeakMap();

export function portal(node: HTMLElement, target: string = "body") {
  portalParents.set(node, node.parentElement);

  const parent = document.querySelector(target);
  parent.appendChild(node);

  return {
    destroy() {
      portalParents.delete(node);
      node.parentNode?.removeChild(node);
    },
  };
}
